import React from "react";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { extractYearMonth } from "../../../../utils/helpers";
import ProfessionalAffiliation from "../../../../../types/ProfessionalAffiliation";
import { DateRangePicker } from "../../../../shared/DateRangePicker";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

interface Props {
  index: number;
  affiliation: ProfessionalAffiliation;
  projectIndex?: number;
  handleInput: (e: any, index: number, projectIndex?: number) => void;
  value: "clientPeriod" | "projectPeriod";
  label: string;
  errors: Record<string, string>;
  removeErrorMessage: (field: string) => void;
}

export const AffiliationDateRangePicker: React.FC<Props> = ({
  index,
  affiliation,
  projectIndex,
  handleInput,
  value,
  label,
  errors,
  removeErrorMessage,
}) => {
  const period =
    value === "clientPeriod"
      ? affiliation.clientPeriod.split(" - ")
      : projectIndex !== undefined
      ? affiliation.projects[projectIndex]?.projectPeriod.split(" - ") || [
          "",
          "",
        ]
      : ["", ""];

  const fieldName =
    value === "clientPeriod"
      ? `affiliations[${index}].clientPeriod`
      : `affiliations[${index}].projects[${projectIndex}].projectPeriod`;

  const error = errors[fieldName] ?? undefined;

  const minDateStart =
    value === "projectPeriod" && affiliation.clientPeriod
      ? dayjs(extractYearMonth(affiliation.clientPeriod, "first"))
      : undefined;

  const minDateEnd =
    value === "clientPeriod"
      ? affiliation.clientPeriod
        ? dayjs(extractYearMonth(affiliation.clientPeriod, "first"))
        : undefined
      : affiliation.projects[projectIndex!]?.projectPeriod
      ? dayjs(
          extractYearMonth(
            affiliation.projects[projectIndex!].projectPeriod,
            "first"
          )
        )
      : dayjs(extractYearMonth(affiliation.clientPeriod, "first"));

  const maxDate =
    value === "projectPeriod" && affiliation.clientPeriod
      ? dayjs(extractYearMonth(affiliation.clientPeriod, "second"))
      : undefined;

  const handlePeriodChange = (newRange: [string, string]) => {
    handleInput(
      {
        target: {
          name: value,
          value: newRange.join(" - "),
        },
      },
      index,
      projectIndex
    );
    removeErrorMessage(fieldName);
  };

  return (
    <DateRangePicker
      label={label}
      value={period as [string, string]}
      onChange={handlePeriodChange}
      minDateStart={minDateStart}
      minDateEnd={minDateEnd}
      maxDate={maxDate}
      error={error}
      clampToBounds={value === "projectPeriod"} 
    />
  );
};
